module.exports = __webpack_public_path__ + "static/media/medikura-background.79738b80.png";